// extracted by mini-css-extract-plugin
export default {"image":"Success_image__cYptm","btn":"Success_btn__NzGkv","message":"Success_message__XT4wt","link":"Success_link__KnDNj"};